<template>

    <table v-if="!scrollable" class="table" :class="classes">
        <caption v-if="pagination">
            <span>{{ pagination | paginationTitle }}</span>
        </caption>
        <slot></slot>
    </table>

    <div v-else id="table-container">
        <table class="table" :class="classes">
            <caption v-if="pagination">
                <span>{{ pagination | paginationTitle }}</span>
            </caption>
            <slot></slot>
        </table>
    </div>

</template>

<style scoped lang="scss">

    // Container
    #table-container {
        border: 1px solid $color-rule;
        overflow: auto;
        width: 100%;
        .table tbody tr:last-child {
            border-bottom: none;
        }
    }

    // Table
    .table {
        background: #fff;
        border-collapse: collapse;
        height: auto;
        margin: 0;
        width: 100%;
        &.table-layout-fixed {
            table-layout: fixed;
        }
        caption {
            @include font-medium(14px);
            background: #fff;
            border: none;
            border-bottom: 1px solid $color-rule;
            caption-side: top;
            color: $color-text;
            padding: 10px 15px;
        }
    }

    // Head
    .table {
        thead {
            background: #fff;
            position: relative;
            width: 100%;
            z-index: 1;
            th {
                @include font-semibold(11px);
                align-items: center;
                background-color: #fff;
                border: none;
                border-bottom: 1px solid $color-rule;
                color: $color-text;
                height: 34px;
                padding: 0 30px 0 15px;
                position: relative;
                text-align: left;
                transition: background-color .3s;
                vertical-align: middle;
                white-space: nowrap;
                &.sortable {
                    cursor: pointer;
                    &:hover {
                        background-color: $color-highlight;
                    }
                    i {
                        color: $color-primary;
                        margin-left: 5px;
                    }
                }
            }
        }
    }

    // Body
    .table {
        tbody {
            tr {
                background: #fff;
                border-top: 1px solid $color-rule-light;
                flex-grow: 0;
                transition: background-color .3s;
                td {
                    @include font-medium(13px);
                    border: none;
                    color: $color-text;
                    height: 44px;
                    overflow: hidden;
                    text-align: left;
                    text-overflow: ellipsis;
                    vertical-align: middle;
                    white-space: nowrap;
                    word-break: break-word;
                    a {
                        color: $color-primary;
                        text-decoration: none;
                        &:hover {
                            color: $color-primary-hover;
                        }
                    }
                }
            }
            tr.table-danger td {
                background: none;
                color: $color-danger !important;
            }
        }
    }

    // Bordered
    .table.table-bordered {
        border: 1px solid $color-rule;
        thead th {
            border-left: none;
            border-right: none;
            border-top: none;
        }
        tbody td {
            border: none;
        }
    }

    // Hover
    .table.table-hover {
        tbody tr {
            cursor: pointer;
            &:hover {
                background: $color-bg;
            }
        }
    }

    // Size
    .table {
        &.table-sm tbody tr td {
            padding: 0 15px;
        }
        &.table-md tbody tr td {
            padding: 15px;
        }
    }

</style>

<script>

export default {

    props: {
        size: {
            type: String,
            default: 'sm',
        },
        fixed: {
            type: Boolean,
            default: false,
        },
        bordered: {
            type: Boolean,
            default: false,
        },
        selectable: {
            type: Boolean,
            default: true,
        },
        scrollable: {
            type: Boolean,
            default: false,
        },
        pagination: {
            type: Object,
            required: false,
        },
    },

    computed: {

        classes() {
            return {
                'table-layout-fixed': this.fixed,
                'table-bordered': this.bordered,
                'table-hover': this.selectable,
                'table-sm': this.size === 'sm',
                'table-md': this.size === 'md',
            };
        },

    },

    mounted() {
        if (this.scrollable) {
            window.addEventListener('resize', this.onResize);
            this.onResize();
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },

    methods: {

        onResize() {
            let width = Math.max(1200, document.body.clientWidth);
            width -= document.getElementById('sidebar').clientWidth;
            width -= 92;
            document.getElementById('table-container').style.width = width + 'px';
        },
    },

}

</script>
